import React from 'react';
import QuestionForm from 'shared/QuestionForm';

export default function ContactSection() {
  return (
    <section className="contact-corporate">
      <div className="container">
        <div className="contact-row">
          <div className="contact-col contact-col--1">
            <div className="contact-text">
              <div className="corp-title">
                Corporate <br />
                Talent Acquisition
              </div>
              <p>
                We’ll be happy to provide you with all of the answers you need!{' '}
                <br />
                Please fill out this form, and we’ll contact you as soon as
                possible.
              </p>
            </div>
          </div>
          <div className="contact-col contact-col--2">
            <div className="contact-form">
              <div className="contact-form__title">Let's Gig in!</div>
              <QuestionForm
                formItemClassName="contact-form__item"
                submitBtnClassName="btn primary-btn size-sm"
                successPopupClassName="corporate-success-popup"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
